import actionTypes from './actionTypes';

const requestZip = () => ({
    type: actionTypes.REQUEST_ZIP
});

const zipResponse = success => ({
    type: actionTypes.ZIP_RESPONSE,
    payload: {
        success,
        errors: []
    }
});

const togglePlayers = (isChecked, playerIds) => ({
    type: actionTypes.TOGGLE_PLAYERS,
    payload: {
        playerIds,
        isChecked
    }
});


export default {
    togglePlayers,
    requestZip,
    zipResponse
};